import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const LineChartDashboard = ({ boxData = [], itemData = [], labels = [] }) => {
    const data = {
        labels: labels.length ? labels : Array.from({ length: 30 }, (_, i) => `${i + 1} Day`),
        datasets: [
            {
                label: "Box",
                data: boxData,
                borderColor: "#2d8edb",
                backgroundColor: "#2d8edb",
                tension: 0.3,
                fill: false,
                pointRadius: 0,
                borderWidth: 2,
            },
            {
                label: "Item",
                data: itemData,
                borderColor: "#4caf50",
                backgroundColor: "#4caf50",
                tension: 0.3,
                fill: false,
                pointRadius: 0,
                borderWidth: 2,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                labels: {
                    title: null
                }
            },
            legend: {
                position: "top",
                labels: {
                    boxWidth: 12,
                    padding: 20,
                },
            },
            // title: {
            //     display: true,
            //     text: "Last 30 Days Scanning (Item & Box)",
            //     font: { size: 16 },
            //     align: "start",
            // },
        },
        scales: {
            x: {
                ticks: {
                    autoSkip: false,
                    callback: function (val, index) {
                        const day = index + 1;
                        if ([1, 10, 20, 30].includes(day)) {
                            return `${day} ${day === 1 ? 'Day' : 'Days'}`;
                        }
                        return '';
                    },
                    maxRotation: 0,
                    minRotation: 0,
                },
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 5,
                },
            },
        },
    };

    return (
        <>
            <div className="cdashboard_box_top">
                <div className="cdashboard_box_top_left">
                    <h4>Last 30 Days Scanning (Item & Box)</h4>
                </div>
                {/* <div className="cdashboard_box_top_right">
                    <ul>
                        {data.datasets.map((dataset, index) => (
                            <li key={index}>
                                <span style={{ backgroundColor: dataset.borderColor }}></span>
                                {dataset.label}
                            </li>
                        ))}
                    </ul>
                </div> */}
            </div>
            <div className="cdashboard_box_last">
                <Line data={data} options={options} />
            </div>
        </>
    );
};

export default LineChartDashboard

